import { FC, useEffect, useState } from "react";

import { Model } from "./Model/Model"
import { Data } from "../types/TypeData";
import { Box } from "@chakra-ui/react";
import Masonry from "react-masonry-css";
import "../../css/PinterstGrid.css"

type Props = {
  moveData: Data[];
}

const breakpointColumnsObj = {
  default: 3
};

export const MoveDataCard: FC<Props> = (props) => {
  // Props from DataJudge
  const { moveData } = props

  // 移動するカードが70未満だったら、すぐに下まで到達するので、2倍表示する。
  // だいたい100個のカードがあれば、下までたどり着くのに5分かかる。
  // if (selectData.length <= 70) {
  //   selectData.push(...selectData);
  // }

  return (
    <>
      <Masonry
        breakpointCols={breakpointColumnsObj}
        className="my-masonry-grid"
        columnClassName="my-masonry-grid_column"

      >
        {moveData.map((data) => (
          <Model
            key={data.TOPIC_ID}
            Title={data.TOPIC_TITLE}
            Medias={data.MEDIAS}
            WallLikes={data.WALL_LIKES}
            TopicAuthorName={data.TOPIC_AUTHOR_NAME}
            TopicBody={data.TOPIC_BODY}
            CategoryID={data.CATEGORY_ID}
            TopicID={data.TOPIC_ID}
          />
        ))}
      </Masonry>
      <div style={{ margin: '60px' }}></div>
      {window.innerHeight > window.innerWidth && <div style={{ margin: '400px' }}></div>}
    </>
  )
}